import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import { loading, spinner } from './styles';

const Loading = () => (
    <div className="loading-container">
        <div style={loading}>
            <ProgressSpinner
                style={spinner}
                strokeWidth="1"
                fill="#EEEEEE"
                animationDuration=".5s"
            />
        </div>
    </div>
);

export default Loading;
